//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import  * as Actions from "./actions"



const player_selecter  = (state) => state.currentGameSession
export const useCurrentGameSession = () => {
    const currentGameSession = useSelector(player_selecter, shallowEqual)
    const dispatch = useDispatch();
    const setCurrentGameSession  = (state)=>{
        dispatch(Actions.setCurrentGameSession(state))
    }
    const updateCurrentGameSession  = (state)=>{
        dispatch(Actions.updateCurrentGameSession(state))
    }
    const clearCurrentGameSession  = ()=>{
        dispatch(Actions.clearCurrentGameSession())
    }
   return {currentGameSession,setCurrentGameSession,updateCurrentGameSession,clearCurrentGameSession} 
}
